import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { firstValueFrom, map, Observable, withLatestFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
/**
 * This guard redirects all authenticated users to the newsfeed page
 * Unauthenticated users are not redirected.
 */
export class RedirectToNewsfeedGuard extends KeycloakAuthGuard {
  private newsfeedDisabled$: Observable<boolean | undefined>;
  constructor(
    protected override router: Router,
    private keycloak: KeycloakService,
    private features: DataAccessTogglesFacade,
    private fairsFacade: DataAccessFairsFacade
  ) {
    super(router, keycloak);
    this.newsfeedDisabled$ = this.features.flag('kill-newsfeed');
  }

  public async isAccessAllowed() {
    if (this.authenticated) {
      return firstValueFrom(
        this.newsfeedDisabled$.pipe(
          withLatestFrom(this.fairsFacade.fairId$),
          map(([newsfeedDisabled, fairId]) => {
            if (newsfeedDisabled) {
              return this.router.parseUrl(`/fairs/${fairId}/search`);
            } else {
              return this.router.parseUrl('/newsfeed');
            }
          })
        )
      );
    } else return true;
  }
}
